export default "__VITE_ASSET__0sn3CXW___"